import { get, toString } from 'lodash/fp';

function decodeEntrant(data = {}) {
  return {
    id: toString(data.id),
    avatar: get('avatar', data),
    countryImage: get('country.flag', data),
    countryName: get('country.name', data),
    entryCount: get('entry_count', data),
    isFriend: !!get('is_friend', data),
    isUltimateChampion: !!get('is_king', data),
    isVIP: !!get('is_vip', data),
    userName: get('name', data)
  };
}

export default decodeEntrant;
